var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 20.625a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75zM16.5 20.625a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75zM19.25 4.813H4.001l-.564-2.888a.688.688 0 0 0-.687-.55H0V2.75h2.186l2.627 13.2a.687.687 0 0 0 .687.55h12.375v-1.375H6.064l-.564-2.75h12.375a.687.687 0 0 0 .688-.536l1.375-6.188a.688.688 0 0 0-.688-.838zM17.325 11H5.239l-.963-4.812h14.115L17.325 11z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.a7c3220f3ad4adb7680a1b852880bfea.svg";
export { ForwardRef as ReactComponent };